import React, { useState } from 'react';
import { Row, Col, Card, Select } from 'antd';
import {
  CardTitleText,
  MenuItemText,
  TableColumnTitle,
} from '../../../../../../shared/globalStyling/styledText';
import BasketItemTable from './BasketItemTable';
import { colors } from '../../../../../../../core/utils/constants/listOfColors';
import BasketItemRingChart from './BasketItemRingChart';

const { Option } = Select;

const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleBasketItems: {
    backgroundColor: '#fff',
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  campaignCardStyleBasketItems,
  campaignCardStyle,
} = Style;

const Extra = ({ setBasketItemDimension }) => {
  const options = [
    {
      value: 'quantity',
      text: 'Quantity',
    },
    {
      value: 'total',
      text: 'Total',
    },
  ];
  return (
    <Row type="flex" justify="space-between" align="middle">
      <Col style={{ paddingRight: '10px' }} span={8}>
        <CardTitleText text={'Breakdown'} />
      </Col>
      <Col span={16}>
        <Row type="flex" justify="end" align="middle">
          <span style={{ marginRight: '10px' }}>
            <TableColumnTitle text={'Show By:'} />
          </span>
          <Select
            style={{ width: '60%' }}
            defaultValue={options[1].value}
            onChange={(value) => {
              setBasketItemDimension(value);
            }}
          >
            {options.map((option, index) => {
              return (
                <Option key={index} value={option.value}>
                  <MenuItemText text={option.text} />
                </Option>
              );
            })}
          </Select>
        </Row>
      </Col>
    </Row>
  );
};

const BasketItemTitleWithSearch = ({ searchTerms, onSearchChange }) => {
  return (
    <Row type="flex" justify="space-between" align="middle">
      <Col>
        <CardTitleText text={'Basket Items'} />
      </Col>
      <Col>
        <Select
          mode="tags"
          placeholder="Search basket items"
          value={searchTerms}
          onChange={onSearchChange}
          style={{ width: '300px' }}
          tokenSeparators={[',']}
          allowClear
          size="small"
        />
      </Col>
    </Row>
  );
};

const BasketItemDetails = ({
  basketItems = [],
  searchTerms,
  onSearchChange,
}) => {
  const [basketItemDimension, setBasketItemDimension] = useState('total');

  // Sort by total (descending)
  const sortedBasketItems = [...basketItems].sort((a, b) => (b.total || 0) - (a.total || 0));

  // Assign colors and value field to each basket item based on their index
  const basketItemsWithColors = sortedBasketItems.map((item, index) => ({
    ...item,
    color: colors[index % colors.length],
    value: item.name || `basket-item-${index}`,
  }));

  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleBasketItems}
          headStyle={{ borderWidth: '3px', height: '66px' }}
          bodyStyle={{ padding: 0 }}
          title={
            <BasketItemTitleWithSearch
              searchTerms={searchTerms}
              onSearchChange={onSearchChange}
            />
          }
        >
          <BasketItemTable basketItemData={basketItemsWithColors} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleBasketItems}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px', height: '66px' }}
          title={<Extra setBasketItemDimension={setBasketItemDimension} />}
        >
          <BasketItemRingChart
            data={basketItemsWithColors}
            height={campaignCardStyle.height}
            selectedBasketItemDimension={basketItemDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default BasketItemDetails;
